import {
  ServiceValues,
  isServiceValuesResponse,
} from '@internal/backstage-plugin-release-common';
import { ReleaseReadState, useReleaseRead } from '../useReleaseRead';

export type ServiceValuesState = ReleaseReadState<ServiceValues>;

/** What one service's overlays hold in every environment, as committed in
 * gitops-platform. */
export function useServiceValues(service: string): ServiceValuesState {
  return useReleaseRead({
    route: 'values',
    search: `service=${encodeURIComponent(service)}`,
    isResponse: isServiceValuesResponse,
    shape: 'Values',
  });
}
